import type { PermissionPreset } from '@/api/types';

export function presetDisplayName(presetKey: string, presets: readonly PermissionPreset[] | undefined): string {
  return presets?.find((preset) => preset.key.toLowerCase() === presetKey.toLowerCase())?.displayName ?? presetKey;
}
